export const formatAddress = (address: any): string => {
    if (!address) return '';

    const addressParts = [
        address.line_1,
        address.line_2,
        address.zip,
        address.city,
        address.region,
        address.country,
    ];

    return addressParts.filter(Boolean).join(', ');
};